import React from 'react';
import {Chip} from '@mui/material';
import AutoAwesomeRounded from '@mui/icons-material/AutoAwesomeRounded';

const C = {
  indigo100: '#E0E7FF',
  indigo700: '#2839C9',
};

/**
 * Small brand chip used in marketing surfaces (landing hero,
 * /get install hero). Same visual treatment, different copy per
 * page — pass `label` and optionally an icon. Defaults to the
 * AutoAwesome (sparkles) glyph from the reference designs.
 */
export interface BrandChipProps {
  label: string;
  icon?: React.ReactElement;
}

export function BrandChip({
  label,
  icon = <AutoAwesomeRounded sx={{fontSize: 14}} />,
}: BrandChipProps): React.JSX.Element {
  return (
    <Chip
      icon={icon}
      label={label}
      size="small"
      sx={{
        height: 28,
        px: 1.5,
        fontSize: 12,
        fontWeight: 600,
        bgcolor: C.indigo100,
        color: C.indigo700,
        borderRadius: 999,
        '& .MuiChip-icon': {color: C.indigo700, ml: 0.5, mr: -0.5},
      }}
    />
  );
}

export default BrandChip;
